import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, Avatar, Flex, Stack, VStack, useColorModeValue, Divider, Icon } from '@chakra-ui/react';
import { Quote } from 'lucide-react';
const Testimonial = ({
  name,
  role,
  content,
  avatarUrl
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const quoteColor = useColorModeValue('blue.100', 'blue.800');
  return <Box bg={cardBg} p={8} borderRadius="lg" boxShadow="md" position="relative" zIndex={1} border="1px" borderColor={borderColor} data-id="element-315">
      <Icon as={Quote} position="absolute" top={4} right={4} boxSize={8} color={quoteColor} data-id="element-316" />
      <Text fontSize="lg" mb={6} fontStyle="italic" color={useColorModeValue('gray.600', 'gray.300')} data-id="element-317">
        "{content}"
      </Text>
      <Flex align="center" data-id="element-318">
        <Avatar src={avatarUrl} name={name} size="md" mr={4} data-id="element-319" />
        <Stack spacing={0} data-id="element-320">
          <Text fontWeight="bold" data-id="element-321">{name}</Text>
          <Text fontSize="sm" color={useColorModeValue('gray.600', 'gray.400')} data-id="element-322">
            {role}
          </Text>
        </Stack>
      </Flex>
    </Box>;
};
export function Testimonials() {
  const bgColor = useColorModeValue('white', 'gray.900');
  const testimonials = [{
    name: 'David Asante',
    role: 'CTO, TechAfrica',
    content: "George's technical expertise is matched only by his leadership skills. He delivered our platform on time and has been instrumental in our growth.",
    avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80'
  }, {
    name: 'Abena Mensah',
    role: 'Founder, EduTech Ghana',
    content: 'Working with George transformed our STEM program. His passion for education and technical knowledge created an incredible learning experience for our students.',
    avatarUrl: 'https://images.unsplash.com/photo-1619895862022-09114b41f16f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80'
  }, {
    name: 'Michael Osei',
    role: 'Product Manager, GhanaPayments',
    content: 'George built our payment system from scratch, integrating multiple providers and ensuring security at every step. His work is thorough and reliable.',
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=774&q=80'
  }];
  return <Box py={20} width="100%" bg={bgColor} data-id="element-323">
      <Container maxW="1200px" data-id="element-324">
        <VStack spacing={12} data-id="element-325">
          <VStack spacing={4} textAlign="center" maxW="800px" data-id="element-326">
            <Heading as="h2" size="xl" data-id="element-327">
              What People Say
            </Heading>
            <Divider width="100px" borderColor="blue.500" borderWidth={2} data-id="element-328" />
            <Text fontSize="lg" color={useColorModeValue('gray.600', 'gray.300')} data-id="element-329">
              Feedback from clients and colleagues I've worked with
            </Text>
          </VStack>
          <SimpleGrid columns={{
          base: 1,
          md: 3
        }} spacing={10} data-id="element-330">
            {testimonials.map((testimonial, index) => <Testimonial key={index} {...testimonial} data-id="element-331" />)}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>;
}